import { gql } from '@apollo/client'

const dealStatusSelection = `{
  riskStatus
  riskStatusColor
  dealRiskFlag
  euvCompletedFlag
  euvDescription
  lastStatus
  lastComment
  didError
  errorMessage
  dealStatus
}`

const dealSummarySelection = `{
  dealNumber
  dealSourceDealType
  dealVersionNumber
  dealVersionDate
  opportunityId
  dealOpgNumber
  customerName
  customerCountry
  customerSegmentCode
  shipBeginDate
  shipEndDate
  dealProgramCode
  bdmeApprovalCode
  quoteDistCode
  busModelCode
  mcChargeCode
  country
  region
  dealDescription
  statusNotes
  dealSourceCode
  dealSourceID
  winLossStatus
  dealSourceKeyValue
  tenantCode
  tenantId
  internalNotes
  dealType
  versionStatus
  hierarchyCode
  sourceDealDescription
  busGroupCode
}`

export const COUNTRY_RESTRICTIONS_SELECTION = `
  countryRestriction {
    countryCd
    countryName
    restrictionType
    customerNumber
    otherPartySiteInstanceId
  }
`

const regionalSettingsSelection = `{
  region
  regionCode
  mainCountry
  mainCountryCode
  businessModel
  businessModelCode
  dealLanguage
  multiCountryEnableFlag
  showDecimalFl
  geographicalScope
}`

const dealDatesSelection = `{
  dealDate {
    label
    beginDate
    endDate
  }
  orderDate {
    label
    beginDate
    endDate
  }
  dueDeliverDate {
    label
    bidDue
    deliveryBy
  }
}`
const GET_DEAL_INFO_QUERY = gql`
  query getDealInfo ($dealId: Int!, $dealNumber: Int!) {
    dealStatus (dealId: $dealNumber) ${dealStatusSelection}
    dealSummary (dealId: $dealId) ${dealSummarySelection}
    regionalSettings (dealId: $dealId) ${regionalSettingsSelection}
    dealDates (dealId: $dealId) ${dealDatesSelection}
  }
`

export default GET_DEAL_INFO_QUERY
